export const Cross = () => {
    return (
        <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6 7" stroke="var(--fg-gray1-white)" strokeLinecap="round" />
            <path d="M6.00781 1L1.00781 7" stroke="var(--fg-gray1-white)" strokeLinecap="round" />
        </svg>
    );
};
